import $ from 'jquery';
import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import { initJqueryEvents } from '@shared/utils/misc.ts';
import { App } from '@my-pages/App.tsx';

class MyPages {
    constructor() {
        // @ts-ignore
        window.jquery = window.jQuery = window.$ = $;

        const container = document.getElementById('taf-my-pages-app');
        if (!container) return;

        const root = createRoot(container);
        root.render(
            <StrictMode>
                <App />
            </StrictMode>,
        );
        initJqueryEvents();
    }
}

new MyPages();
